import { render, staticRenderFns } from "./FormRadioButtonGroup.vue?vue&type=template&id=2852dfc9&scoped=true&"
import script from "./FormRadioButtonGroup.vue?vue&type=script&lang=js&"
export * from "./FormRadioButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852dfc9",
  null
  
)

export default component.exports